import { render, staticRenderFns } from "./selectColor.vue?vue&type=template&id=3a05ec4c&"
import script from "./selectColor.vue?vue&type=script&lang=js&"
export * from "./selectColor.vue?vue&type=script&lang=js&"
import style0 from "./selectColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports